import PropTypes from 'prop-types';

const propTypes = {
  datasetId: PropTypes.number.isRequired,
};

const defaultProps = {};

const DatasetAttributesMap = ({ datasetId }) => <div>todo {datasetId}</div>;

DatasetAttributesMap.propTypes = propTypes;
DatasetAttributesMap.defaultProps = defaultProps;

export { DatasetAttributesMap };
